import CustomDatepickField from "./CustomDatepickField.js";
import CustomListField from "./CustomListField.js";
import CustomPhoneField from "./CustomPhoneField.jsx";
import RegistrationPasswordField from "components/Reusable/Form/Reusable/RegistrationPasswordField.tsx";
import {
  EMAIL_VALIDATOR,
  mediumPassRegex,
  strongPassRegex,
} from "helpers/validators.js";

//left side Form (profile details)
export const MyProfileFields = {
  UserFirstName: {
    fieldKey: "UserFirstName",
    element: "input",
    type: "text",
    title: "First Name",
    label: "profileuserdetails-firstname",
    placeholder: "profileuserdetails-firstname",
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "default-input-invalid-message",
    },
    containerClassName: "input",
  },
  UserLastName: {
    fieldKey: "UserLastName",
    element: "input",
    type: "text",
    title: "LastName",
    label: "profileuserdetails-lastname",
    placeholder: "profileuserdetails-lastname",
    validation: {
      required: true,
      reg: /[^\n]+/,
      invalidMessage: "default-input-invalid-message",
    },
    containerClassName: "input",
  },
  UserEmail: {
    fieldKey: "UserEmail",
    element: "input",
    type: "email",
    title: "Email",
    label: "profileuserdetails-email",
    placeholder: "profile-email-placeholder",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: EMAIL_VALIDATOR,
    },
    containerClassName: "input",
  },
  UserPhone: {
    fieldKey: "UserPhone",
    type: "tel",
    title: "Phone Number",
    label: "profileuserdetails-mobilephone",
    placeholder: "profileuserdetails-mobilephone",
    element: "customelement",
    render: (props) => <CustomPhoneField {...props} />,
    containerClassName: "customElementPhone",
  },
  UserBirthdate: {
    fieldKey: "UserBirthdate",
    // element: "input",
    // type: "date",
    title: "UserBirthdate",
    label: "profileuserdetails-birthdate",
    placeholder: "profileuserdetails-birthdate",
    element: "customelement",
    render: (props) => <CustomDatepickField {...props} />,
    containerClassName: "customElementBirthday",
  },
  UserOccupation: {
    fieldKey: "UserOccupation",
    element: "select",
    title: "Occupation",
    label: "profileuserdetails-occupation",
    placeholder: "profileuserdetails-occupation",
    fieldName: "occupation",
    selectList: [],

    containerClassName: "input",
  },
  TypeSelectList: {
    element: "customelement",
    fieldKey: "TypeSelectList",
    title: "Country",
    render: (props) => <CustomListField {...props} />,
    containerClassName: "customElementCountries",
    label: "profileuserdetails-country",
  },
  UserGender: {
    fieldKey: "UserGender",
    element: "radio",
    title: "Gender",
    label: "profileuserdetails-gender",
    optionsList: [
      { value: "male", label: "profileuserdetails-gender-male" },
      { value: "female", label: "profileuserdetails-gender-female" },
    ],
    validation: {
      required: true,
      invalidMessage: "gender-require-text",
    },
    containerClassName: "input",
  },
};

//Right side Form (Password)
export const PasswordFields = {
  UserCurrentPassword: {
    fieldKey: "UserCurrentPassword",
    element: "input",
    type: "password",
    title: "UserCurrentPassword",
    label: "profileuserdetails-current-password",
    placeholder: "profileuserdetails-current-password",
    hidePassStrength: true,
    validation: {
      required: true,
      invalidMessage: "signin-password-tooltip-text",
      reg: /[^\n]+/,
    },
    containerClassName: "input",
  },
  UserNewPassword: {
    fieldKey: "UserNewPassword",
    element: "customelement",
    type: "password",
    title: "UserNewPassword",
    label: "profileuserdetails-password",
    placeholder: "profileuserdetails-password",
    tooltip: {
      text: "signin-password-medium-tooltip-text",
    },
    validation: {
      required: true,
      invalidMessage: "signin-password-medium-tooltip-text",
      reg: mediumPassRegex,
    },
    render: (props) => <RegistrationPasswordField {...props} />,
    containerClassName: "input",
  },
  ConfirmPassword: {
    fieldKey: "ConfirmPassword",
    element: "input",
    type: "password",
    title: "ConfirmPassword",
    label: "profileuserdetails-confirm-password",
    placeholder: "profileuserdetails-confirm-password",
    hidePassStrength: true,
    validation: {
      required: true,
      invalidMessage: "signin-password-medium-tooltip-text",
      reg: mediumPassRegex,
    },
    containerClassName: "input",
  },
};
